import { render, staticRenderFns } from "./FeedbackUpload.vue?vue&type=template&id=1c3c5ce0&"
import script from "./FeedbackUpload.vue?vue&type=script&lang=js&"
export * from "./FeedbackUpload.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackUpload.vue?vue&type=style&index=0&id=1c3c5ce0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports